import { inject, Injectable } from '@angular/core'
import { LogService } from './log.service'
import { environment } from 'src/environments/environment'
import { IEnvironment } from '../interfaces/environment.interface'

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {

  private _logger = inject(LogService)

  private _environment!: IEnvironment

  constructor() {
    this._environment = environment
    this._logger.debug('Environment file set to: ', this._environment)
  }

  get(): IEnvironment {
    return this._environment
  }

}
